import { OverlayBanner } from '@/components/shared/OverlayBanner';
import { VoiCreationControlsOverlay } from './VoiCreationControlsOverlay';
import { Typography } from '@mui/material';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { useAtomValue } from 'jotai';
import * as poiState from '../../state';
import * as cuboidState from '../../../cuboids';
import { useMemo } from 'react';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';

const InitialHintOverlay = () => (
  <OverlayBanner
    sx={{ mb: 2, py: 2, px: 3 }}
    icon={<AbyssIcon iconName="cuboid-yellow" size="lg" />}
  >
    <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
      Select the first <strong>point</strong> to create VOI around it
    </Typography>
  </OverlayBanner>
);

export const VoiCreationHintsOverlay = () => {
  const editPointOfInterest = useAtomValue(poiState.editPointOfInterest);
  const isCuboidEditorEnabled = useAtomValue(cuboidState.isCuboidEditorEnabled);
  const state = useMemo(() => editPointOfInterest.state, [editPointOfInterest.state]);

  const show = useMemo(() => {
    return (
      state !== 'Inactive' &&
      state !== 'WaitingForTransition' &&
      editPointOfInterest.template?.type === PointOfInterestTemplateTypeEnum.VolumeOfInterest
    );
  }, [state, editPointOfInterest.template?.type]);
  if (!show) return <></>;
  if (editPointOfInterest.formState === 'Create') return <></>;

  // Show the initial hint overlay
  if (state === 'WaitingForPoint') return <InitialHintOverlay />;

  // Show the controls if the cuboid is being edited
  if (isCuboidEditorEnabled) return <VoiCreationControlsOverlay />;

  return <></>;
};
